import { QueryClientProvider } from "@tanstack/react-query";

import { PackageSwitcherContainer } from "app/components/React/Modals/PackageSwitcherContainer";
import { AddonStateProvider } from "app/contexts/AddonStateContext/AddonStateContext";
import queryClient from "single-spa/react-app/query-client";

import { FitScoreProvider } from "../FitScoreContext/FitScoreContext";
import { MessagesContextProvider } from "../MessagesContext/MessagesContext";
import { NoTouchPurchaseProvider } from "../NoTouchPurchaseContext/NoTouchPurchaseContext";

interface IContextLayerProps {
    children: React.ReactNode;
}

export const ContextLayer = ({ children }: IContextLayerProps) => {
    // NOTE: Make sure the contexts are nested in the correct order
    return (
        <QueryClientProvider client={queryClient}>
            <MessagesContextProvider>
                <PackageSwitcherContainer />
                <FitScoreProvider>
                    <AddonStateProvider>
                        <NoTouchPurchaseProvider>{children}</NoTouchPurchaseProvider>
                    </AddonStateProvider>
                </FitScoreProvider>
            </MessagesContextProvider>
        </QueryClientProvider>
    );
};
